export function createNotificationOrchestratorClient(transport) {
    return {
        /**
         * Messages to couriers on shift, by zone or group
         *
         * Requires scope: broadcast:read
         */
        listBroadcasts(options) {
            return transport.request({
                method: "GET",
                path: "/v1/broadcasts",
                options,
            });
        },
        /**
         * Send a message to couriers matching an audience
         *
         * Requires scope: broadcast:send
         */
        sendBroadcast(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/broadcasts",
                body,
                options,
            });
        },
        /**
         * Route one idempotent transactional notification
         *
         * Requires scope: notifications:route
         */
        routeNotification(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/notifications`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=notification-orchestrator.js.map